module.exports = __webpack_public_path__ + "img/jumbotron_under.b5441fa4.jpg";